export const MIGRATION_NOTICE_DISMISSED_AT_KEY = 'migrationNoticeDismissedAt';
export const MIGRATION_HANDOFF_STARTED_AT_KEY = 'migrationHandoffStartedAt';
export const MIGRATION_HANDOFF_TARGET_KEY = 'migrationHandoffTarget';
export const MIGRATION_NOTICE_INTERVAL_MS = 4 * 24 * 60 * 60 * 1000;

function browserStorage(storage) {
  if (storage) return storage;
  if (typeof window === 'undefined') return null;

  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

/** Return whether the recurring migration notice should be shown now. */
export function shouldShowMigrationNotice(storage, now = Date.now()) {
  const targetStorage = browserStorage(storage);
  if (!targetStorage) return true;

  try {
    if (targetStorage.getItem(MIGRATION_HANDOFF_STARTED_AT_KEY)) return false;

    const dismissedAt = Number(targetStorage.getItem(MIGRATION_NOTICE_DISMISSED_AT_KEY));
    if (!Number.isFinite(dismissedAt) || dismissedAt <= 0) return true;
    return now - dismissedAt >= MIGRATION_NOTICE_INTERVAL_MS;
  } catch {
    return true;
  }
}

/** Dismiss the migration notice until its four-day reminder interval has elapsed. */
export function dismissMigrationNotice(storage, now = Date.now()) {
  const targetStorage = browserStorage(storage);
  if (!targetStorage) return;

  try {
    targetStorage.setItem(MIGRATION_NOTICE_DISMISSED_AT_KEY, String(now));
  } catch {
    // Storage may be unavailable in restricted browser contexts.
  }
}

/** Stop future reminders after a migration handoff has been started. */
export function markMigrationHandoffStarted(target, storage, now = Date.now()) {
  const targetStorage = browserStorage(storage);
  if (!targetStorage) return;

  try {
    targetStorage.setItem(MIGRATION_HANDOFF_STARTED_AT_KEY, String(now));
    targetStorage.setItem(MIGRATION_HANDOFF_TARGET_KEY, target);
  } catch {
    // Storage may be unavailable in restricted browser contexts.
  }
}
